// const baton =
//   "https://firebasestorage.googleapis.com/v0/b/zarajskij-hleb.appspot.com/o/uploads%2Fbaton%402x-50.jpg?alt=media&token=9a11b2b8-5438-4c80-8c88-f415dff66f12";

// import banner1 from "./assets/photos/main/banner@2x.png";
// import banner2 from "./assets/photos/main/banner2@2x.png";
// import banner3 from "./assets/photos/main/banner3@2x.png";
// import banner4 from "./assets/photos/main/banner4@2x.jpg";

// import bread_1 from "./assets/photos/main/bread_1@2x.png";
// import bun1 from "./assets/photos/main/bun1@2x.png";
// import bun2 from "./assets/photos/main/bun2@2x.png";
// import bun3 from "./assets/photos/main/bun3@2x.png";
// import bun4 from "./assets/photos/main/bun4@2x.png";
// import bun5 from "./assets/photos/main/bun5@2x.png";

// import cheese1 from "./assets/photos/main/cheese1@2x.png";
// import cheese2 from "./assets/photos/main/cheese2@2x.png";
// import corn from "./assets/photos/main/corn@2x.png";
// import footer from "./assets/photos/main/footer@2x.png";
// import honey from "./assets/photos/main/honey@2x.png";

// import kreml from "./assets/photos/main/kreml@2x.png";
// import truck from "./assets/photos/main/truck@2x.png";
// import news from "./assets/photos/main/news@2x.png";
// import mapMask from "./assets/photos/partners/map-mask.svg";

// import arrowLongIcon from "./assets/icons/arrow-long.svg";
// import locationMarkerIcon from "./assets/icons/location-marker.svg";
// import preloaderIcon from "./assets/icons/preloader.svg";

// import photo1 from "./assets/photos/history/photo1@2x.png";
// import photo2 from "./assets/photos/history/photo2@2x.png";
// import prize1 from "./assets/photos/history/prize1@2x.png";
// import prize2 from "./assets/photos/history/prize2@2x.png";
// import crumbs2 from "./assets/photos/history/crumbs_2@2x.png";
// import recipe from "./assets/photos/history/recipe@2x.png";
// import rozh1_1 from "./assets/photos/history/rozh1_1@2x.png";
// import job from "./assets/photos/history/job.svg";

// import news1 from "./assets/photos/news_card/news1@2x.png";

// import bread1 from "./assets/photos/catalog/bread1@2x-50.jpg";
// import bread2 from "./assets/photos/catalog/bread2@2x-50.jpg";
// import bread3 from "./assets/photos/catalog/bread3@2x-50.jpg";
// import bread4 from "./assets/photos/catalog/bread4@2x-50.jpg";
// import bread5 from "./assets/photos/catalog/bread5@2x-50.jpg";
// import bread6 from "./assets/photos/catalog/bread6@2x-50.jpg";
// import zerno from "./assets/photos/catalog/zerno@2x.png";

// import partner1 from "./assets/photos/partners/partner1@2x.png";
// import partner2 from "./assets/photos/partners/partner2@2x.png";
// import partner3 from "./assets/photos/partners/partner3@2x.png";
// import partner4 from "./assets/photos/partners/partner4@2x.png";
export default {
  socialMedias: [
    { icon: "icon-facebook", href: "/", network: "facebook" },
    { icon: "icon-vkontakte", href: "/", network: "vk" },
    { icon: "icon-telegram", href: "/", network: "telegram" },
  ],
  // navigation: {
  //   menu: [
  //     {
  //       title: "Продукция",
  //       href: "/product",
  //       visible: true,
  //     },
  //     {
  //       title: "О хлебокомбинате",
  //       href: "/history",
  //       visible: true,
  //     },
  //     {
  //       title: "Партнерам",
  //       href: "/business",
  //       visible: true,
  //     },
  //     {
  //       title: "Новости",
  //       href: "/news",
  //       visible: true,
  //     },
  //     {
  //       title: "Контакты",
  //       href: "/contacts",
  //       visible: true,
  //     },
  //   ],
  // },
  // main: {
  //   header: {
  //     logoTitle: "Зарайский хлебокомбинат",
  //     copyright: "© 1933–2019<br/>«Зарайский хлебокомбинат»",
  //   },

  //   footer: {
  //     info: {
  //       desc: "© 1933–2019<br/>«Зарайский хлебокомбинат»",
  //       policy: {
  //         title: "Пользовательское соглашение",
  //         href: "/policy",
  //       },
  //       legal: {
  //         title: "Правовая информация",
  //         href: "/legal",
  //       },
  //       madein:
  //         "Сделано в «<a class='link inverse' href='https://www.bermudas.pro/' target='blank'>Бермудах</a>»<br/>в 2019 году",
  //     },
  //     menu: {
  //       list: [
  //         {
  //           title: "Главная",
  //           href: "/",
  //           visible: true,
  //         },
  //         {
  //           title: "Продукция",
  //           href: "/product",
  //           visible: true,
  //         },
  //         {
  //           title: "О хлебокомбинате",
  //           href: "/history",
  //           visible: true,
  //         },
  //         {
  //           title: "Партнерам",
  //           href: "/business",
  //           visible: true,
  //         },
  //         {
  //           title: "Новости",
  //           href: "/news",
  //           visible: true,
  //         },
  //         {
  //           title: "Контакты",
  //           href: "/contacts",
  //           visible: true,
  //         },
  //       ],
  //     },
  //     contacts: {
  //       place: "Московская область, г. Зарайск, ул. Привокзальная, д.11",
  //       phone: [
  //         { number: "+7 (905) 595-82-32" },
  //         { number: "+7 (905) 595-82-60" },
  //         { number: "+7 (496) 662-48-30" },
  //       ],
  //       email: "info@zarhleb.ru",
  //     },
  //   },
  // },

  // home: {
  //   meta: {
  //     title: "Зарайский хлебокомбинат",
  //     description: "Зарайский хлебокомбинат",
  //     keywords: "Зарайский хлебокомбинат",
  //     img: { src: "" },
  //   },
  //   banner: {
  //     list: [
  //       {
  //         img: {
  //           src: banner1,
  //         },
  //         text: {
  //           title: "Работаем для вас <br/><strong>с 1933 года!</strong>",
  //           desc:
  //             "ООО «Зарайский хлебокомбинат» — одно из старейших предприятий городского округа Зарайск, в 2018 году отметившее 85-летие. ",
  //         },
  //         button: "Узнать подробнее",
  //         href: "/history",
  //       },

  //       {
  //         img: {
  //           src: banner2,
  //         },
  //         text: {
  //           title: "Работаем для вас <br/><strong>с 1933 года!</strong>",
  //           desc:
  //             "ООО «Зарайский хлебокомбинат» — одно из старейших предприятий городского округа Зарайск, в 2018 году отметившее 85-летие. ",
  //         },
  //         button: "Узнать подробнее",
  //         href: "/history",
  //       },
  //       {
  //         img: {
  //           src: banner3,
  //         },
  //         text: {
  //           title: "Работаем для вас <br/><strong>с 1933 года!</strong>",
  //           desc:
  //             "ООО «Зарайский хлебокомбинат» — одно из старейших предприятий городского округа Зарайск, в 2018 году отметившее 85-летие. ",
  //         },
  //         button: "Узнать подробнее",
  //         href: "/history",
  //       },
  //       {
  //         img: {
  //           src: banner4,
  //         },
  //         text: {
  //           title: "Работаем для вас <br/><strong>с 1933 года!</strong>",
  //           desc:
  //             "ООО «Зарайский хлебокомбинат» — одно из старейших предприятий городского округа Зарайск, в 2018 году отметившее 85-летие. ",
  //         },
  //         button: "Узнать подробнее",
  //         href: "/history",
  //       },
  //     ],
  //   },
  //   advantage: {
  //     title: "Гармоничное сочетание ручного и машинного труда",
  //     desc:
  //       "Помимо автоматизированного производства на предприятии работают высококлассные мастера-хлебопеки, считающие, что главное в хлебе — натуральные продукты и добрые руки мастеров.",
  //     list: [
  //       {
  //         icon: "icon-hleb1",
  //         title: "5,5 тонн продукции ежедневно",
  //         desc:
  //           "С каждым годом спрос на нашу продукцию стабильно растет. Ассортимент хлебобулочной продукции за последние 3 года вырос со 112 до 176 наименований.",
  //         art: {
  //           img: {
  //             src: "",
  //             alt: "",
  //           },
  //           float_img: {
  //             src: "",
  //             alt: "",
  //           },
  //         },
  //       },
  //       {
  //         icon: "icon-kamin",
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "На сегодняшний день наше предприятие единственное в Московской области, сохранившее классические, традиционные технологии производства хлеба, выпечка которого производится в настоящих каменных печах.",
  //         art: {
  //           img: {
  //             src: "",
  //             alt: "",
  //           },
  //           float_img: {
  //             src: "",
  //             alt: "",
  //           },
  //         },
  //       },
  //       {
  //         icon: "",
  //         title: "",
  //         desc: "",
  //         art: {
  //           img: {
  //             src: banner2,
  //             alt: "",
  //           },
  //           float_img: {
  //             src: bun1,
  //             alt: "",
  //           },
  //         },
  //       },
  //       {
  //         icon: "icon-hleb2",
  //         title: "Большой выбор мучной продукции",
  //         desc:
  //           "Выпускаемая продукция разнообразна: хлеб ржано-пшеничный, изготавляемый на молочно-кислых густых заквасках, хлеб пшеничный по опарной технологии, хлеб деревенский, фруктово-постный, хлеб из гречихи, многозерновой хлеб, бездрожжевой, а также сдобные мучные кондитерские изделия.",
  //         art: {
  //           img: {
  //             src: "",
  //             alt: "",
  //           },
  //           float_img: {
  //             src: "",
  //             alt: "",
  //           },
  //         },
  //       },
  //       {
  //         icon: "",
  //         title: "",
  //         desc: "",
  //         art: {
  //           img: {
  //             src: banner3,
  //             alt: "",
  //           },
  //           float_img: {
  //             src: bun2,
  //             alt: "",
  //           },
  //         },
  //       },
  //     ],
  //   },
  //   quality: {
  //     info: {
  //       title: "Строгий контроль качества",
  //       desc:
  //         "Обязательный входной контроль поставляемого сырья, производственный контроль на стадии изготовления продукции, а также ежедневная 100% реализация готовых изделий, и, конечно же, ответственность и любовь к своему делу.",
  //       icon: "icon-sertificate",
  //     },
  //   },
  //   prod: {
  //     info: {
  //       title: "Мы открываем новые производственные линии",
  //       desc:
  //         "Помимо производства хлебобулочных и кондитерских изделий, мы запустили производство молочной продукции, для изготовления которого используется натуральное коровье молоко.",
  //       button: "Перейти в каталог",
  //       href: "/product",
  //     },
  //     list: [
  //       {
  //         title: "Хлебобулочные изделия",
  //         icon: "icon-bread",
  //         href: "/product",
  //         images: [{ src: bun3, alt: "" }],
  //       },
  //       {
  //         title: "Кондитерские изделия",
  //         icon: "icon-cake",
  //         href: "/product",
  //         images: [{ src: bun4, alt: "" }, { src: bun5, alt: "" }],
  //       },
  //       {
  //         title: "Молочная продукция",
  //         icon: "icon-cheese",
  //         href: "/product",
  //         images: [
  //           { src: cheese2, alt: "" },
  //           { src: cheese1, alt: "" },
  //           { src: honey, alt: "" },
  //         ],

  //       },
  //     ],
  //   },
  //   cards: {
  //     list: [
  //       {
  //         title: "Где можно приобрести нашу продукцию?",
  //         desc:
  //           "Наша продукция представлена в торговых точках на территории Зарайского, Озёрского, Луховицкого, Коломенского и Серебряно-Прудского районов. В рамках улучшения качества обслуживания населения и полного удовлетворения спроса мы планируем открыть собственную сеть фирменных магазинов.",
  //         img: { src: kreml },
  //         href: "/contacts",
  //         button: "Перейти к Контакты",
  //       },
  //       {
  //         title: "Зарайский хлебокомбинат&nbsp;— бизнесу",
  //         desc:
  //           "Мы заинтересованы в создании долгосрочных отношений с партнерами на взаимовыгодных условиях. Работая с нами Вы получаете гарантированную стабильность, высокую прибыль и востребованность рынком.",
  //         img: { src: truck },
  //         href: "/business",
  //         button: "Узнать подробнее",
  //       },
  //     ],
  //   },
  //   news: {
  //     info: {
  //       title: "Новости",
  //       button: "Все новости",
  //       href: "/news",
  //     },
  //     list: [
  //       {
  //         title: "Названы регионы с лучшим хлебом",
  //         date: "1 мая 2019",
  //         href: "/news1",
  //       },
  //       {
  //         title: "«Так вкусно, что за ушами трещало»",
  //         date: "20 апреля 2019",
  //         href: "/news2",
  //       },
  //       {
  //         title:
  //           "Одежда, хлеб, вода, парикмахерская — то, в чем мы всегда будем нуждаться.",
  //         date: "3 февраля 2019",
  //         href: "/news2",
  //       },
  //     ],
  //   },
  // },
  // about: {
  //   meta: {
  //     title: "Зарайский хлебокомбинат",
  //     description: "Зарайский хлебокомбинат",
  //     keywords: "Зарайский хлебокомбинат",
  //     img: { src: "" },
  //   },
  //   history: {
  //     title: "История хлебокомбината",
  //     list: [
  //       {
  //         title: "Зарождение",
  //         desc:
  //           "<p>Зарайский хлебокомбинат построен в 1933 году методом народной стройки. С 1962 по 1970 год на комбинате проведено полное техническое перевооружение всего производства. Практически полностью заменено физически изношенное и морально устаревшее технологическое оборудование.</p>",
  //         date: "1933",
  //         img: {
  //           src: photo1,
  //           alt: "Зарождение",
  //         },
  //       },
  //       {
  //         title: "Установка печи ХПП",
  //         desc:
  //           "<p>В 1970 г установили Печь ХПП — 25 для производства ржано-пшеничного хлеба, две печи ФТЛ — 2 для производства подовых сортов из пшеничной муки.</p><p>Осуществлена реконструкция котельной, перевод её с твердого топлива на газ. Пристроены дополнительные вспомогательные помещения: механическая мастерская, склад подсобного сырья, Красный уголок. Расширена экспедиция готовой продукции, деревянные перекрытия заменены на железобетонные. Произведен ремонт всех производственных и бытовых помещений. Построено новое здание контрольно-пропускного пункта с металлическими воротами, заасфальтирована территория предприятия.</p>",
  //         date: "1970",
  //         img: {
  //           src: photo2,
  //           alt: "Установка печи ХПП",
  //         },
  //       },
  //       {
  //         title: "Установка печи «Муссон-ротор»",
  //         desc:
  //           "<p>В 2005 г установили печь «Муссон-ротор» для выпечки мелкоштучных изделий.</p>",
  //         date: "2005",
  //         img: {
  //           src: photo2,
  //           alt: "Установка печи «Муссон-ротор»",
  //         },
  //       },
  //       {
  //         title: "Усовершенствования",
  //         desc:
  //           "<p>С 2013 г по настоящее время ведётся работа по замене тесторазделочного оборудования для батонов. Ввели в эксплуатацию тестоокруглитель, тестозакаточную машину фирмы «Восход», шкаф предварительной расстойки.</p>",
  //         date: "2013",
  //         img: {
  //           src: photo2,
  //           alt: "Усовершенствования",
  //         },
  //       },
  //     ],
  //   },
  //   recipes: {
  //     title: "Старинные рецептуры",
  //     list: [
  //       {
  //         title: "Хлеб по-деревенски",
  //         desc:
  //           "Издавна на Руси известно было немало рецептов выпечки вкусного и ароматного, подолгу не черствеющего хлеба. В прошлом веке особенно славилась своими хлебами Киево-Печерская Лавра. Принятая в обители технология хлебопечения будущий военный министр России А. Н. Куропаткин рекомендовал для применения в некоторых армейских подразделениях. Ценность этого рецепта не утрачена и сегодня.",
  //         recipe: {
  //           title: "Рецепт",
  //           desc:
  //             "<p>День 1. Утром возьмите не железную и лучше даже не эмалированную, а керамическую или на худой конец стеклянную емкость объемом не менее 1,5 литра. Наливаем туда 100 мл теплой кипяченой воды, засыпаем постепенно 100 г ржаной муки, перемешиваем, чтобы не было комков. Накрываем салфеткой, ставим в теплое место. Если делаете в банке, то заверните ее во что-то. Мешайте не железной ложкой, а деревянной лопаточкой или чем-то типа того. Лучше мешать деревянной ложкой, а все манипуляции проводить в крынке.</p>" +
  //             "<p>День 2. На следующее утро на поверхности должны появиться пузыри, если их нет — ничего страшного, это только значит, что в том месте, где вы оставили емкость недостаточно тепло. Добавляем еще 100 мл теплой воды и 100 г ржаной муки, перемешиваем как следует и опять накрываем салфеткой, оставляем в теплом месте.</p>" +
  //             "<p>День 3. Утром проделываем те же манипуляции, что и в предыдущее утро: добавляем 100 мл теплой воды и 100 г ржаной муки.</p>",
  //         },
  //         img: {
  //           src: recipe,
  //           alt: "",
  //         },
  //       },
  //       {
  //         title: "Хлеб по-деревенски",
  //         desc:
  //           "Издавна на Руси известно было немало рецептов выпечки вкусного и ароматного, подолгу не черствеющего хлеба. В прошлом веке особенно славилась своими хлебами Киево-Печерская Лавра. Принятая в обители технология хлебопечения будущий военный министр России А. Н. Куропаткин рекомендовал для применения в некоторых армейских подразделениях. Ценность этого рецепта не утрачена и сегодня.",
  //         recipe: {
  //           title: "Рецепт",
  //           desc:
  //             "<p>День 1. Утром возьмите не железную и лучше даже не эмалированную, а керамическую или на худой конец стеклянную емкость объемом не менее 1,5 литра. Наливаем туда 100 мл теплой кипяченой воды, засыпаем постепенно 100 г ржаной муки, перемешиваем, чтобы не было комков. Накрываем салфеткой, ставим в теплое место. Если делаете в банке, то заверните ее во что-то. Мешайте не железной ложкой, а деревянной лопаточкой или чем-то типа того. Лучше мешать деревянной ложкой, а все манипуляции проводить в крынке.</p>" +
  //             "<p>День 2. На следующее утро на поверхности должны появиться пузыри, если их нет — ничего страшного, это только значит, что в том месте, где вы оставили емкость недостаточно тепло. Добавляем еще 100 мл теплой воды и 100 г ржаной муки, перемешиваем как следует и опять накрываем салфеткой, оставляем в теплом месте.</p>" +
  //             "<p>День 3. Утром проделываем те же манипуляции, что и в предыдущее утро: добавляем 100 мл теплой воды и 100 г ржаной муки.</p>",
  //         },
  //         img: {
  //           src: recipe,
  //           alt: "",
  //         },
  //       },
  //       {
  //         title: "Хлеб по-деревенски",
  //         desc:
  //           "Издавна на Руси известно было немало рецептов выпечки вкусного и ароматного, подолгу не черствеющего хлеба. В прошлом веке особенно славилась своими хлебами Киево-Печерская Лавра. Принятая в обители технология хлебопечения будущий военный министр России А. Н. Куропаткин рекомендовал для применения в некоторых армейских подразделениях. Ценность этого рецепта не утрачена и сегодня.",
  //         recipe: {
  //           title: "Рецепт",
  //           desc:
  //             "<p>День 1. Утром возьмите не железную и лучше даже не эмалированную, а керамическую или на худой конец стеклянную емкость объемом не менее 1,5 литра. Наливаем туда 100 мл теплой кипяченой воды, засыпаем постепенно 100 г ржаной муки, перемешиваем, чтобы не было комков. Накрываем салфеткой, ставим в теплое место. Если делаете в банке, то заверните ее во что-то. Мешайте не железной ложкой, а деревянной лопаточкой или чем-то типа того. Лучше мешать деревянной ложкой, а все манипуляции проводить в крынке.</p>" +
  //             "<p>День 2. На следующее утро на поверхности должны появиться пузыри, если их нет — ничего страшного, это только значит, что в том месте, где вы оставили емкость недостаточно тепло. Добавляем еще 100 мл теплой воды и 100 г ржаной муки, перемешиваем как следует и опять накрываем салфеткой, оставляем в теплом месте.</p>" +
  //             "<p>День 3. Утром проделываем те же манипуляции, что и в предыдущее утро: добавляем 100 мл теплой воды и 100 г ржаной муки.</p>",
  //         },
  //         img: {
  //           src: recipe,
  //           alt: "",
  //         },
  //       },
  //     ],
  //   },
  //   achivements: {
  //     title: "Наши достижения",
  //     list: [
  //       {
  //         title:
  //           "<span class='indent'>&laquo;Высокое качество продукции 2017&raquo;</span>",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //         img: {
  //           src: prize1,
  //           alt: "«Высокое качество продукции 2017»",
  //         },
  //       },
  //       {
  //         title:
  //           "<span class='indent'>&laquo;Лучший продукт Подмосковья 2016&raquo;</span>",
  //         desc:
  //           "В 2016 году наша предприятие было отмечено кубком 2 степени премии «Лучший продукт Подмосковья» за кондитерское изделие — сочник с творогом.",
  //         img: {
  //           src: prize2,
  //           alt: "«Лучший продукт Подмосковья 2016»",
  //         },
  //       },
  //     ],
  //   },
  //   vacancies: {
  //     title: "Вакансии",
  //     img: {
  //       src: job,
  //       alt: "Вакансии",
  //     },
  //     list: [
  //       {
  //         title: "Кондитер<br/>мучнисто-кондитерских изделий",
  //         button: "Откликнуться",
  //         href: "/contacts",
  //       },
  //       {
  //         title: "Мастер производства цельномолочной и молочной продукции",
  //         button: "Откликнуться",
  //         href: "/contacts",
  //       },
  //     ],
  //   },
  // },
  // newslist: {
  //   news1: {
  //     title:
  //       "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news1",
  //     id: 1,
  //   },
  //   news2: {
  //     title:
  //       "2 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news2",
  //     id: 2,
  //   },
  //   news3: {
  //     title:
  //       "3 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news3",
  //     id: 3,
  //   },
  //   news4: {
  //     title:
  //       "4 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news4",
  //     id: 4,
  //   },
  //   news5: {
  //     title:
  //       "5 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news5",
  //     id: 5,
  //   },
  //   news6: {
  //     title:
  //       "6 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news6",
  //     id: 6,
  //   },
  //   news7: {
  //     title:
  //       "7 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news7",
  //     id: 7,
  //   },
  //   news8: {
  //     title:
  //       "8 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news8",
  //     id: 8,
  //   },
  //   news9: {
  //     title:
  //       "9 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news9",
  //     id: 9,
  //   },
  //   news10: {
  //     title:
  //       "10 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news10",
  //     id: 10,
  //   },
  //   news11: {
  //     title:
  //       "11 СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: news1,
  //       alt:
  //         "СМИ: Работников магазинов в Сызрани заставили портить просроченный хлеб",
  //     },
  //     short:
  //       "Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. ",
  //     desc:
  //       '<p>Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети.</p>' +
  //       "<p>По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>" +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора. Раздать хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>" +
  //       '<p>В Сызрани работников одной из федеральных сетей магазинов обязали портить и выбрасывать хлеб спустя пять дней после выпуска. Об этом сообщает местный портал "КТВ-ЛУЧ" со ссылкой на работников торговой сети. По словам сотрудников, приказ пришёл от руководства и не является инициативой местных управляющих, однако продавцов это возмущает, так как хлеб можно было бы раздать нуждающимся.</p>' +
  //       "<p>Вместо этого они вынуждены перед утилизацией поливать хлеб грязной водой или посыпать углём, чтобы у продуктов не было товарного вида. Раздать же хлеб они не могут, так как это, как отмечается, противоречит требованиям Роспотребнадзора.</p>",
  //     tag: "новость",
  //     button: "Подробнее",
  //     href: "/news11",
  //     id: 11,
  //   },
  // },
  // news: {
  //   meta: {
  //     title: "Зарайский хлебокомбинат",
  //     description: "Зарайский хлебокомбинат",
  //     keywords: "Зарайский хлебокомбинат",
  //     img: { src: "" },
  //   },
  //   news: {
  //     title: "Важные события, анонсы и&nbsp;специальные предложения",
  //     button: "Показать еще",
  //     list: [
  //       {
  //         tag: "новость",
  //         date: "16 августа 2014",
  //         title: "В парке искусств МУЗЕОН пройдет «Фестиваль хлеба»",
  //         desc:
  //           "Участники фестиваля познакомят гостей с разнообразными мучными изделиями и традиционными видами хлеба. Посетители парка смогут попробовать хлеб, выпеченный в классической печи.",
  //         button: "Подробнее",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //         href: "/news1",
  //       },
  //       {
  //         tag: "новость",
  //         date: "16 августа 2014",
  //         title: "В парке искусств МУЗЕОН пройдет «Фестиваль хлеба»",
  //         desc:
  //           "Участники фестиваля познакомят гостей с разнообразными мучными изделиями и традиционными видами хлеба. Посетители парка смогут попробовать хлеб, выпеченный в классической печи.",
  //         button: "Подробнее",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //         href: "/news1",
  //       },
  //       {
  //         tag: "анонс",
  //         date: "16 августа 2014",
  //         title: "В парке искусств МУЗЕОН пройдет «Фестиваль хлеба»",
  //         desc:
  //           "Участники фестиваля познакомят гостей с разнообразными мучными изделиями и традиционными видами хлеба. Посетители парка смогут попробовать хлеб, выпеченный в классической печи.",
  //         button: "Подробнее",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //         href: "/news1",
  //       },
  //       {
  //         tag: "новость",
  //         date: "16 августа 2014",
  //         title: "В парке искусств МУЗЕОН пройдет «Фестиваль хлеба»",
  //         desc:
  //           "Участники фестиваля познакомят гостей с разнообразными мучными изделиями и традиционными видами хлеба. Посетители парка смогут попробовать хлеб, выпеченный в классической печи.",
  //         button: "Подробнее",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //         href: "/news1",
  //       },
  //       {
  //         tag: "предложение",
  //         date: "16 августа 2014",
  //         title: "В парке искусств МУЗЕОН пройдет «Фестиваль хлеба»",
  //         desc:
  //           "Участники фестиваля познакомят гостей с разнообразными мучными изделиями и традиционными видами хлеба. Посетители парка смогут попробовать хлеб, выпеченный в классической печи.",
  //         button: "Подробнее",
  //         img: {
  //           src: news1,
  //           alt: "В парке искусств МУЗЕОН пройдет «Фестиваль хлеба»",
  //         },
  //         href: "/news1",
  //       },
  //     ],
  //   },
  // },
  // products: {
  //   info: {
  //     title: "Продукция",
  //     count: "{0} товаров",
  //     search: {
  //       placeholder: "Поиск",
  //       icon: "icon-search",
  //     },
  //   },
  //   categories: {
  //     list: [
  //       {
  //         id: 1,
  //         title: "Хлебобулочные изделия",
  //         desc:
  //           "Под маркой «Зарайский хлебокомбинат» ежедневно производится много разнообразной,вкусной и полезной выпечки.",
  //         sub: {
  //           title: "Лучшее качество продукции",
  //           desc:
  //             "Закупаем зерно у крупных агрохолдингов с проверенной репутацией",
  //           img: {
  //             src: zerno,
  //             alt: "",
  //           },
  //         },
  //       },
  //       {
  //         id: 2,
  //         title: "Кондитерские изделия",
  //         desc:
  //           "Под маркой «Зарайский хлебокомбинат» ежедневно производится много разнообразной,вкусной и полезной выпечки.",
  //         sub: {
  //           title: "Лучшее качество продукции",
  //           desc:
  //             "Закупаем зерно у крупных агрохолдингов с проверенной репутацией",
  //           img: {
  //             src: zerno,
  //             alt: "",
  //           },
  //         },
  //       },
  //     ],
  //     subcategories: {
  //       list: [
  //         {
  //           category: 1,
  //           id: 1,
  //           title: "Хлеб из пшеничной муки",
  //           icon: "icon-wheat",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 1,
  //           id: 2,
  //           title: "Хлеб из смеси ржаной и пшеничной муки",
  //           icon: "icon-bread",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 1,
  //           id: 3,
  //           title: "Булочные изделия",
  //           icon: "icon-buns",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 1,
  //           id: 4,
  //           title: "Сдобные изделия",
  //           icon: "icon-loaf",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 1,
  //           id: 5,
  //           title: "Слоеные изделия",
  //           icon: "icon-croissant",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 2,
  //           id: 6,
  //           title: "Торты",
  //           icon: "icon-cake",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 2,
  //           id: 7,
  //           title: "Пирожные",
  //           icon: "icon-cake2",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 2,
  //           id: 8,
  //           title: "Кексы",
  //           icon: "icon-cake3",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 2,
  //           id: 9,
  //           title: "Пряники",
  //           icon: "icon-gingerbread",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         {
  //           category: 2,
  //           id: 10,
  //           title: "Печенье ",
  //           icon: "icon-cookie",
  //           desc:
  //             "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши ",
  //         },
  //         // {
  //         //   id: 11,
  //         //   title: "Другое",
  //         //   icon: "other",
  //         //   desc:
  //         //     "Уловите свое руки мощные вдохновение вкладывает в ваши уловите свое руки мощные вдохновение вкладывает в ваши "
  //         // }
  //       ],
  //     },
  //   },
  // },
  // productslist: {
  //   product1: {
  //     id: 1,
  //     category: 1,
  //     subcategory: 1,
  //     title: "Батон нарезной",
  //     desc:
  //       "Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая. Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая.",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: bread1,
  //       alt: "Батон нарезной",
  //     },
  //     gallery: {
  //       list: [
  //         {
  //           img: {
  //             src: bread1,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread1,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread1,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //       ],
  //     },
  //     nutritions: {
  //       protein: 7.5,
  //       fat: 1.01,
  //       carbohydrates: 47.3,
  //       energy: 229,
  //     },
  //     meta: {
  //       title: "Зарайский хлебокомбинат",
  //       description: "Зарайский хлебокомбинат",
  //       keywords: "Зарайский хлебокомбинат",
  //       img: { src: baton },
  //     },
  //   },
  //   product2: {
  //     id: 2,
  //     category: 1,
  //     subcategory: 1,
  //     title: "Батон нарезной (нарезка)",
  //     desc:
  //       "Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая. Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая.",
  //     date: "2019-07-12T12:00",

  //     img: {
  //       src: bread2,
  //       alt: "Батон нарезной (нарезка)",
  //     },
  //     gallery: {
  //       list: [
  //         {
  //           img: {
  //             src: bread2,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread2,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread2,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //       ],
  //     },
  //     nutritions: {
  //       protein: 7.5,
  //       fat: 1.01,
  //       carbohydrates: 47.3,
  //       energy: 229,
  //     },
  //     meta: {
  //       title: "Зарайский хлебокомбинат",
  //       description: "Зарайский хлебокомбинат",
  //       keywords: "Зарайский хлебокомбинат",
  //       img: { src: baton },
  //     },
  //   },
  //   product3: {
  //     id: 3,
  //     category: 1,
  //     subcategory: 1,
  //     title: "Багет Подмосковский",
  //     desc:
  //       "Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая. Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая.",
  //     date: "2019-07-12T12:00",

  //     img: {
  //       src: bread3,
  //       alt: "Багет Подмосковский",
  //     },
  //     gallery: {
  //       list: [
  //         {
  //           img: {
  //             src: bread3,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread3,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread3,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //       ],
  //     },
  //     nutritions: {
  //       protein: 7.5,
  //       fat: 1.01,
  //       carbohydrates: 47.3,
  //       energy: 229,
  //     },
  //     meta: {
  //       title: "Зарайский хлебокомбинат",
  //       description: "Зарайский хлебокомбинат",
  //       keywords: "Зарайский хлебокомбинат",
  //       img: { src: baton },
  //     },
  //   },
  //   product4: {
  //     id: 4,
  //     category: 1,
  //     subcategory: 1,
  //     title: "Батон Молодежный",
  //     desc:
  //       "Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая. Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая.",
  //     date: "2019-07-12T12:00",

  //     img: {
  //       src: bread4,
  //       alt: "Батон Молодежный",
  //     },
  //     gallery: {
  //       list: [
  //         {
  //           img: {
  //             src: bread4,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread4,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread4,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //       ],
  //     },
  //     nutritions: {
  //       protein: 7.5,
  //       fat: 1.01,
  //       carbohydrates: 47.3,
  //       energy: 229,
  //     },
  //     meta: {
  //       title: "Зарайский хлебокомбинат",
  //       description: "Зарайский хлебокомбинат",
  //       keywords: "Зарайский хлебокомбинат",
  //       img: { src: baton },
  //     },
  //   },
  //   product5: {
  //     id: 5,
  //     category: 1,
  //     subcategory: 1,
  //     title: "Хлеб Шотландский",
  //     desc:
  //       "Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая. Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая.",
  //     date: "2019-07-12T12:00",

  //     img: {
  //       src: bread5,
  //       alt: "Хлеб Шотландский",
  //     },
  //     gallery: {
  //       list: [
  //         {
  //           img: {
  //             src: bread5,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread5,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread5,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //       ],
  //     },
  //     nutritions: {
  //       protein: 7.5,
  //       fat: 1.01,
  //       carbohydrates: 47.3,
  //       energy: 229,
  //     },
  //     meta: {
  //       title: "Зарайский хлебокомбинат",
  //       description: "Зарайский хлебокомбинат",
  //       keywords: "Зарайский хлебокомбинат",
  //       img: { src: baton },
  //     },
  //   },
  //   product6: {
  //     id: 6,
  //     category: 1,
  //     subcategory: 1,
  //     title: "Хлеб солодово-отрубной",
  //     desc:
  //       "Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая. Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая.",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: bread6,
  //       alt: "Хлеб солодово-отрубной",
  //     },
  //     gallery: {
  //       list: [
  //         {
  //           img: {
  //             src: bread6,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread6,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread6,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //       ],
  //     },
  //     nutritions: {
  //       protein: 7.5,
  //       fat: 1.01,
  //       carbohydrates: 47.3,
  //       energy: 229,
  //     },
  //     meta: {
  //       title: "Зарайский хлебокомбинат",
  //       description: "Зарайский хлебокомбинат",
  //       keywords: "Зарайский хлебокомбинат",
  //       img: { src: baton },
  //     },
  //   },
  //   product7: {
  //     id: 7,
  //     category: 1,
  //     subcategory: 1,
  //     title: "Батон простой",
  //     desc:
  //       "Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая. Мука пшеничная хлебопекарная первый сорт, мука ржаная обдирная, мука пшеничная второго сорта, солод, дрожжи хлебопекарные прессованные, соль поваренная пищевая.",
  //     date: "2019-07-12T12:00",
  //     img: {
  //       src: bread1,
  //       alt: "Батон простой",
  //     },
  //     gallery: {
  //       list: [
  //         {
  //           img: {
  //             src: bread1,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread1,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //         {
  //           img: {
  //             src: bread1,
  //             alt: "Батон нарезной",
  //           },
  //         },
  //       ],
  //     },
  //     nutritions: {
  //       protein: 7.5,
  //       fat: 1.01,
  //       carbohydrates: 47.3,
  //       energy: 229,
  //     },
  //     meta: {
  //       title: "Зарайский хлебокомбинат",
  //       description: "Зарайский хлебокомбинат",
  //       keywords: "Зарайский хлебокомбинат",
  //       img: { src: baton },
  //     },
  //   },
  // },
  // product: {
  //   meta: {
  //     title: "Зарайский хлебокомбинат",
  //     description: "Зарайский хлебокомбинат",
  //     keywords: "Зарайский хлебокомбинат",
  //     img: { src: "" },
  //   },
  //   info: {
  //     title: "Состав",
  //     nutritions: "Энергетическая ценность на 100 грамм",
  //     button: "Назад в каталог",
  //   },
  // },
  // contacts: {
  //   meta: {
  //     title: "Зарайский хлебокомбинат",
  //     description: "Зарайский хлебокомбинат",
  //     keywords: "Зарайский хлебокомбинат",
  //     img: { src: "" },
  //   },
  //   info: {
  //     title: "Офис",
  //     desc:
  //       'По всем вопросам качества продукции и предложениям обращаться по адресу <strong><a href="mailto:info@zarhleb.ru">info@zarhleb.ru</a></strong>',
  //     place: {
  //       title: "г. Зарайск",
  //       address: "ул. Привокзальная, д.11",
  //       phone: [
  //         { number: "+7 (905) 595-82-32" },
  //         { number: "+7 (905) 662-44-48" },
  //         { number: "+7 (496) 662-48-30" },
  //       ],
  //       location: {
  //         lat: 54,
  //         lng: 35,
  //       },
  //     },
  //   },
  //   outlets: {
  //     title: "Торговые точки",
  //     list: [
  //       {
  //         title: "г. Зарайск",
  //         desc: "ул. Красноармейская, д.44",
  //         phone: [],
  //         coords: {
  //           lat: 53,
  //           lng: 36,
  //         },
  //       },
  //       {
  //         title: "г. Зарайск",
  //         desc: "ул. Октябрьская 6А",
  //         phone: [],
  //         coords: {
  //           lat: 51,
  //           lng: 33,
  //         },
  //       },
  //     ],
  //   },
  //   shops: {
  //     title: "Адреса магазинов",
  //     list: [
  //       {
  //         title: "г. Зарайск",
  //         desc: "ул. Октябрьская, д.23",
  //         phone: [],
  //         coords: {
  //           lat: 54,
  //           lng: 35,
  //         },
  //       },
  //       {
  //         title: "г. Зарайск",
  //         desc: "ул. Октябрьская, д.20",
  //         phone: [],
  //         coords: {
  //           lat: 55,
  //           lng: 36,
  //         },
  //       },
  //       {
  //         title: "г. Зарайск",
  //         desc: "ул. Каринское шоссе, д.1А",
  //         phone: [],
  //         coords: {
  //           lat: 56,
  //           lng: 37,
  //         },
  //       },
  //       {
  //         title: "г. Зарайск",
  //         desc: "ул. Красноармейская, д.44",
  //         phone: [],
  //         coords: {
  //           lat: 57,
  //           lng: 38,
  //         },
  //       },
  //       {
  //         title: "г. Зарайск",
  //         desc: "ул. Благоева, д.49",
  //         phone: [],
  //         coords: {
  //           lat: 58,
  //           lng: 39,
  //         },
  //       },
  //       {
  //         title: "г. Зарайск",
  //         desc: "2-микрорайон, д.27",
  //         phone: [],
  //         coords: {
  //           lat: 53,
  //           lng: 34,
  //         },
  //       },
  //       {
  //         title: "г. Серебряные пруды",
  //         desc: "ул. Советская, д.1",
  //         phone: [],
  //         coords: {
  //           lat: 52,
  //           lng: 33,
  //         },
  //       },
  //       {
  //         title: "г. Серебряные пруды",
  //         desc: "ул. Ленина, д.42",
  //         phone: [],
  //         coords: {
  //           lat: 51,
  //           lng: 32,
  //         },
  //       },
  //       {
  //         title: "д. Гололобово",
  //         desc: "д.10",
  //         phone: [],
  //         coords: {
  //           lat: 54,
  //           lng: 35,
  //         },
  //       },
  //     ],
  //   },
  // },
  // partners: {
  //   meta: {
  //     title: "Зарайский хлебокомбинат",
  //     description: "Зарайский хлебокомбинат",
  //     keywords: "Зарайский хлебокомбинат",
  //     img: { src: "" },
  //   },
  //   services: {
  //     title: "Мы можем Вам предложить наши услуги",
  //     list: [
  //       {
  //         icon: "icon-empty",
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //       },
  //       {
  //         icon: "icon-empty",
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //       },
  //       {
  //         icon: "icon-empty",
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //       },
  //       {
  //         icon: "icon-empty",
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //       },
  //       {
  //         icon: "icon-empty",
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //         img: {
  //           src: "",
  //           alt: "",
  //         },
  //       },
  //     ],
  //   },
  //   feedback: {
  //     title: "Отзывы<br/> партнеров",
  //     list: [
  //       {
  //         avatar: partner1,
  //         user: "Алена Лазарева",
  //         company: "Генеральный директор компании «Starbucks»",
  //         desc:
  //           "«Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям»",
  //       },
  //       {
  //         avatar: partner2,
  //         user: "Алена Лазарева",
  //         company: "Генеральный директор компании «Starbucks»",
  //         desc:
  //           "«Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям»",
  //       },
  //       {
  //         avatar: partner3,
  //         user: "Алена Лазарева",
  //         company: "Генеральный директор компании «Starbucks»",
  //         desc:
  //           "«Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям»",
  //       },
  //       {
  //         avatar: partner4,
  //         user: "Иван Иванов",
  //         company: "Генеральный директор компании «Starbucks»",
  //         desc:
  //           "«Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям»",
  //       },
  //     ],
  //   },
  //   geo: {
  //     title: "География",
  //     map: {
  //       places: {
  //         list: [
  //           {
  //             coords: { lat: 55.8, lng: 37.5 },
  //             title: "Центральный офис",
  //             place:
  //               "Москва, ул. Автомоторная, д. 1/3, стр. 2, территория МЗ «Спринт»",
  //             metro: "10 минут от станции «Лихоборы» ",
  //             schedule: {
  //               label: "Режим работы:",
  //               desc: "с Пн по Пт с 8:00 до 20:00",
  //             },
  //             phone: ["+7 (963) 960 30 30", "+7 (495) 797 81 22"],
  //             email:
  //               "<strong><a href='mailto:info@sitename.ru'><span itemprop='email'>info@sitename.ru</span></a></strong>",
  //           },
  //           {
  //             coords: { lat: 55.8, lng: 37.5 },
  //             title: "Центральный офис",
  //             place:
  //               "Москва, ул. Автомоторная, д. 1/3, стр. 2, территория МЗ «Спринт»",
  //             metro: "10 минут от станции «Лихоборы» ",
  //             schedule: {
  //               label: "Режим работы:",
  //               desc: "с Пн по Пт с 8:00 до 20:00",
  //             },
  //             phone: ["+7 (963) 960 30 30", "+7 (495) 797 81 22"],
  //             email:
  //               "<strong><a href='mailto:info@sitename.ru'><span itemprop='email'>info@sitename.ru</span></a></strong>",
  //           },
  //         ],
  //       },
  //     },
  //     pros: {
  //       title: "Мы работаем по Юго-Востоку Московской области",
  //       list: [
  //         {
  //           icon: "icon-magazine",
  //           title: "3",
  //           desc: "фирменных магазина",
  //           plans: {
  //             title: "10",
  //             desc: "Планируется открыть",
  //           },
  //         },
  //         {
  //           icon: "icon-bake",
  //           title: "5,5",
  //           desc: "тонн продукции ежедневно",
  //           plans: {
  //             title: "7",
  //             desc: "тонн планируется производить",
  //           },
  //         },
  //       ],
  //     },
  //   },
  //   faq: {
  //     description: {
  //       title: "Частые вопросы",
  //       desc:
  //         "По всем вопросам качества продукции и предложениям обращаться по адресу info@zarhleb.ru ",
  //     },
  //     list: [
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //       {
  //         title: "Индивидуальная технология производства",
  //         desc:
  //           "Мы — единственные, кто заменяют морально устаревшую технику более эффективной, продолжая выпекать хлеб в настоящей доменной печи. Мы совершенствуем производство, не изменяя традициям.",
  //       },
  //     ],
  //   },
  // },
};
